import { combineReducers } from 'redux';

import preloaderReducer from './preloaderReducer';
import toastifyReducer from './toastifyReducer';

const rootReducer = combineReducers({
  preloader: preloaderReducer,
  toastify: toastifyReducer
});

export default rootReducer;
